export const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const humanDate = date.toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    return humanDate;
}

export const convertDate = (dateString:string) => {
    var date = new Date(dateString);
    return date.getDate()+"."+(date.getMonth() + 1)+"."+date.getFullYear();
}